<h1>CALL FOR PAPERS</h1>

<p>
	CIFRIS24 is an international event, supported and organized by De Cifris, aimed at
	bringing together researchers in the field of cryptography, practitioners, developers, and
	users to foster cooperation and exchange techniques, tools, experiences, and ideas.
	<a href="/cifris24">/cifris24</a>.
</p>

<h2> TOPICS </h2>
<p>
	All topic areas related to cryptography are of interest and in scope.
</p>
<p>
	Suggested topics include but are not restricted to:
</p>
<ul style="list-style-type: none">
	<li> Anonymity and Privacy </li>
	<li> Applied Cryptography and Implementations </li>
	<li> Authentication, Identification and Access Control </li>
	<li> Boolean Functions and Discrete Mathematics </li>
	<li> Complexity-Theoretic Cryptography </li>
	<li> Cryptanalysis </li>
	<li> Cryptocurrencies and Blockchain </li>
	<li> Cryptographic Hash Functions </li>
	<li> Cryptographic Protocols </li>
	<li> Digital Signatures and Message Authentication Codes </li>
	<li> Distributed Systems Security </li>
	<li> Elliptic-Curve Cryptography </li>
	<li> Formal Security Methods </li>
	<li> Information-Theoretic Security </li>
	<li> Post-Quantum Cryptography </li>
	<li> Public-Key Encryption </li>
	<li> Physical Cryptography </li>
	<li> Secure Multiparty Computation </li>
	<li> Symmetric Cryptography </li>
	<li> Zero-Knowledge Proofs </li>
</ul>
<br>
<h2> IMPORTANT DATES </h2>
<ul style="list-style-type: none">
	<li> Conference dates: 25th, 26th and 27th September, 2024 </li>
	<li> Submission deadline: <b>7th May, 2024</b> </li>
	<li> Preliminary acceptance notification: 2nd July, 2024 </li>
	<li> Final acceptance notification: 9th July, 2024 </li>
</ul>
<br>
<h2> SUBMISSIONS AND PROCEEDINGS </h2>
<p>
	Authors who wish to give a talk should prepare an extended abstract of their work consisting of at least 5 pages and
	no more than 30 pages. Only previously unpublished contributions are considered.
</p>
<p>
	After the review round, all accepted papers are required to submit a revised version of their paper, meeting the
	style and page requirements that will be set by the Scientific Committee, for the final acceptance decision.
	Together with this version, also a short draft of the talk slides should be provided, meeting the style and
	requirements that will be set by the Scientific Committee.
</p>
<p>
	Accepted papers can apply for inclusion in a special issue of <a
		href="https://www.degruyter.com/journal/key/jmc/html"><em>Journal of Mathematical Cryptology</em></a> (De
	Gruyter). The journal will further select which papers will be published (in revised form). These papers will be
	published in Open Access and will be free of any charge for the authors, as done last year.
</p>
<p>
	Moreover, all authors, whether they publish in JMC or in any other form, will be required to provide a
	<b>two-page</b> mini-abstract to appear in CIFRIS24 Acta, which is a volume of our book series De Cifris Koine.
</p>
<p>
	The reviews of submissions are performed by the Programme Committee, under the guidance of the two Chairs.
</p>

<h2> INSTRUCTIONS FOR AUTHORS </h2>
<ul>
	<li>
		Electronic submission of non-anonymous papers via EasyChair.
	</li>
	<li>
		Papers must be typeset using LaTeX in the <a
			href="https://www.overleaf.com/latex/templates/springer-lecture-notes-in-computer-science/kzwwpvhwnvfj">LNCS</a>
		style.
	</li>
	<li>
		We encourage authors to typeset the paper using Springer's LNCS LaTeX package with no changes to the style.
		Paper's length should range from 5 to 30 pages, excluding references and clearly marked appendices. Programme
		Committee members are not required to read appendices, so the paper should be intelligible without them.
	</li>
	<li>
		Papers must be written in English, and begin with a title, a short abstract, and a list of keywords. An
		introduction section should summarize the paper's contributions at a level appropriate for a non-specialist
		reader.
	</li>
	<li>
		Submissions must be in PDF format.
	</li>
	<li>
		Upon acceptance, the authors will revise their papers and change the Latex style according to the publication
		medium.
	</li>
</ul>

<h2> PRESENTATION </h2>
<p>
	Authors of accepted papers must guarantee that their paper will be presented at the conference.
</p>

<hr><!---------------------------------------------------------------->
<app-program-committee24></app-program-committee24>
<hr><!---------------------------------------------------------------->
<app-submission24></app-submission24>